import React, { useState, useEffect, useMemo } from 'react';
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	Spinner,
	Alert,
} from 'reactstrap';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import { getMeasurementDetailQuery } from '../../../slices/thunks';

const MeasurementSMADetailModal = ({
	measurement,
	isOpen,
	handleToggleModal,
}) => {
	const columns = useMemo(
		() => [
			{
				header: 'Código SIEP',
				accessorKey: 'siep_code',
				dataType: 'multi-select',
				align: 'center',
			},
			{
				header: 'Región',
				accessorKey: 'region_centro',
				dataType: 'multi-select',
				titlecase: true,
				align: 'center',
			},
			{
				header: 'Barrio',
				accessorKey: 'barrio_centro',
				dataType: 'multi-select',
				align: 'center',
			},
			{
				header: 'Establecimiento',
				accessorKey: 'nombre_centro',
				dataType: 'multi-select',
				titlecase: true,
				align: 'center',
			},
			{
				header: 'Titular',
				accessorKey: 'titular_centro',
				dataType: 'multi-select',
				titlecase: true,
				align: 'center',
			},
			{
				header: 'Fecha',
				accessorKey: 'timestamp_clp',
				dataType: 'datetime',
				defaultSort: 'desc',
				align: 'center',
			},
			{
				header: 'Dispositivo',
				accessorKey: 'sensor_name',
				dataType: 'multi-select',
				align: 'center',
			},
			{
				header: 'Posición',
				accessorKey: 'position',
				dataType: 'multi-select',
				titlecase: true,
				align: 'center',
			},
			{
				header: 'Profundidad',
				accessorKey: 'depth',
				dataType: 'multi-select',
				align: 'center',
			},
			{
				header: 'Status SMA',
				accessorKey: 'sma_response_data.status',
				dataType: 'multi-select',
				Cell: ({ row }) => {
					let status = row.original.sma_response_data?.status;
					let bgColor =
						status === 'enviado'
							? '#d7f2e4'
							: status === 'pendiente'
							? '#fff3d1'
							: '#ffe3dc';
					let txColor =
						status === 'enviado'
							? '#45cc86'
							: status === 'pendiente'
							? '#e8a800'
							: '#f06448';
					return (
						<span
							className={`badge`}
							style={{ backgroundColor: bgColor, color: txColor }}
						>
							{status ? status : '-'}
						</span>
					);
				},
				align: 'center',
			},
			{
				header: 'Mensaje SMA',
				accessorFn: row => row.sma_response_data?.mensaje || '',
				titlecase: true,
				align: 'center',
			},
			{
				header: 'Fecha SMA',
				accessorFn: row => row.sma_response_data?.timestamp || null,
				dataType: 'datetime',
				align: 'center',
			},
			{
				header: 'Min. Oxígeno',
				accessorKey: 'min_oxygen',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
			{
				header: 'Max. Oxígeno',
				accessorKey: 'max_oxygen',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
			{
				header: 'Prom. Oxígeno',
				accessorKey: 'avg_oxygen',
				dataType: 'float.2',
				align: 'center',
			},
			{
				header: 'Std. Dev. Oxígeno',
				accessorKey: 'stddev_oxygen',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
			{
				header: 'Min. Saturación',
				accessorKey: 'min_saturation',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
			{
				header: 'Max. Saturación',
				accessorKey: 'max_saturation',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
			{
				header: 'Prom. Saturación',
				accessorKey: 'avg_saturation',
				dataType: 'float.2',
				align: 'center',
			},
			{
				header: 'Std. Dev. Saturación',
				accessorKey: 'stddev_saturation',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
			{
				header: 'Min. Temperatura',
				accessorKey: 'min_temperature',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
			{
				header: 'Max. Temperatura',
				accessorKey: 'max_temperature',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
			{
				header: 'Prom. Temperatura',
				accessorKey: 'avg_temperature',
				dataType: 'float.2',
				align: 'center',
			},
			{
				header: 'Std. Dev. Temperatura',
				accessorKey: 'stddev_temperature',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
			{
				header: 'Min. Salinidad',
				accessorKey: 'min_salinity',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
			{
				header: 'Max. Salinidad',
				accessorKey: 'max_salinity',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
			{
				header: 'Prom. Salinidad',
				accessorKey: 'avg_salinity',
				dataType: 'float.2',
				align: 'center',
			},
			{
				header: 'Std. Dev. Salinidad',
				accessorKey: 'stddev_salinity',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
		],
		[]
	);

	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={() => handleToggleModal()}
				style={{ maxWidth: '90%' }}
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader toggle={handleToggleModal}>
					Detalle Mediciones
				</ModalHeader>
				<ModalBody className=''>
					<lord-icon
						src='https://cdn.lordicon.com/tdrtiskw.json'
						trigger='loop'
						colors='primary:#f06548,secondary:#405189'
						style={{ width: '90px', height: '90px' }}
					></lord-icon>
					<div className='mt-2'>
						<ODataGrid
							getDataFunc={getMeasurementDetailQuery}
							columns={columns}
							theme='minimal'
							remoteOperations={{
								pagination: true,
								sorting: true,
								filtering: true,
							}}
							defaultPageSize={20}
							baseFilters={{
								siep_code: {
									$eq: measurement.siep_code,
								},
								depth: {
									$eq: measurement.depth,
								},
								timestamp_clp: {
									$eq: new Date(`${measurement.timestamp_clp}Z`),
								},
								sma_response: {
									$exists: true,
								},
							}}
						/>
					</div>
				</ModalBody>
			</Modal>
		</div>
	);
};

export default MeasurementSMADetailModal;
